export default "__VITE_ASSET__b964567a__"